/**
 * @file Mixin to response to window size for root vue app
 */
import { observeWindowSize } from 'bits/window'
import debounce from 'lodash.debounce'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const browser = namespace('browser')

@Component
export default class extends Vue {
  private unobserveWindowSize
  @browser.Action private resizeWindow

  mounted(): void {
    this.resizeWindow({
      height: window.innerHeight,
      width: window.innerWidth,
    })
    this.unobserveWindowSize = observeWindowSize(debounce(this.resizeWindow, 250))
  }

  beforeDestroy(): void {
    this.unobserveWindowSize && this.unobserveWindowSize()
  }
}
